import {useGeneral} from '@contexts/GeneralContext.tsx';
import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {DefaultInfoV1Props, DefaultNavLinkProps, DefaultNavTextFieldProps} from "@models/DefaultProps.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {fullHeight, fullWidth} from '@models/helpers.ts';
import {Grid, TextField, ToggleButton} from '@mui/material';
import {TextFieldNav} from '@shared/custom/TextFieldNav.tsx';
import React, {useEffect, useState} from "react";
import {NavigationLink} from "@shared/custom/NavigationLink.tsx";
import {__usuarios_endpoints} from "@components/usuario/endpoints/__usuarios_endpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {useUsuarioMenu} from "@components/usuario/hooks/useUsuarioMenu.tsx";
import {useAuth} from "@contexts/hooks/UseAuth.tsx";

export interface UsuarioInfoProps extends DefaultInfoV1Props<IUsuario> {
    value: IUsuario,
    usuarioId?: number,
    variant: 'navigationLink' | 'grid' | 'textfield' | 'row'
    slotProps?: DefaultNavLinkProps<IUsuario>['slotProps'] | DefaultNavTextFieldProps<IUsuario>['slotProps'],
    hideYou?: boolean,
}

export function GetUsuarioIfNull(id: number): IUsuario | undefined {
    const [usuario, setUsuario] = useState<IUsuario>()
    const {Get} = useApi()

    useEffect(() => {
        Get(__usuarios_endpoints.GetContas({ids: [id]}, {page: 1, pageSize: 1})).then((x) => {
            if (x.hasData) {
                setUsuario(x.items[0]);
            }
        })
    }, [id])

    return usuario;
}

export const UsuarioInformacao: React.FC<Omit<UsuarioInfoProps, 'value'> & {
    label?: string,
    value?: IUsuario
}> = (props) => {
    const user = props.value ? props.value : GetUsuarioIfNull(props.usuarioId ?? 0);
    if (!user) return <></>;

    if (props.variant == 'navigationLink') return <UsuarioInfoNavLink {...props} value={user}/>;
    if (props.variant == 'grid') return <UsuarioInfoGrid {...props} value={user}/>;
    if (props.variant == 'textfield') return <UsuarioInfoTextField {...props} value={user}/>;
};

export function UsuarioInfoNavLink(props: Omit<UsuarioInfoProps, 'variant' | 'EndComponent' | 'overrides'> & DefaultNavLinkProps<IUsuario>) {
    const {userData} = useAuth()
    const {userContextMenu} = useUsuarioMenu()

    return (<NavigationLink pathName={'/usuarios/detalhes'}
                            onContextMenu={(event) => userContextMenu(event, props.value)}
                            searchData={{usuarioId: props.value.id}}
                            permissoesNecessarias={['VisualizarUsuarios']}
                            chipSx={{...props.slotProps?.chip?.sx}}
                            tableMode={props.slotProps?.chip?.tableMode}
                            label={props.value[props.displayMode || 'nome'] + ` ${!props.hideYou && props.value.id == userData?.id ? '(Você)' : ''}`}
                            toolTipHint={'Ir para a pagina de detalhes do usuario ' + props.value.nome}/>
    );
}

export const UsuarioInfoTextField: React.FC<Omit<UsuarioInfoProps, 'variant' | 'EndComponent'> & DefaultNavTextFieldProps<IUsuario, 'nome'>> = (props) => {
    const {value, label} = props;

    return (<TextFieldNav label={label ?? 'Usuario'}
                          displayValue={value.nome}
                          slotProps={{textField: props.slotProps?.textField}}
                          onClick={props.onClick}
                          pathName={_Sitemap.usuarios.children.detalhes.fullUrl}
                          searchData={{usuarioId: value.id}}/>);
};

export const UsuarioInfoGrid: React.FC<UsuarioInfoProps> = (props) => {
    const {value} = props;
    const {adjustSizeLevel} = useGeneral();

    return <Grid container>

        <Grid size={12}>
            <Grid container spacing={1}>
                <Grid size={adjustSizeLevel({sm: 4, md: 2})}>
                    <TextField disabled fullWidth
                               value={value.id}/></Grid>
                <Grid size={adjustSizeLevel({sm: 8, md: 2})}>
                    <ToggleButton selected={true}
                                  disabled
                                  value={true} sx={{...fullHeight, ...fullWidth}}
                                  color={value.isAtivo ? 'success' : 'error'}
                    >
                        {value.isAtivo ? 'Ativo' : 'Inativo'}
                    </ToggleButton>
                </Grid>
                <Grid size={adjustSizeLevel({sm: 12, md: 8})}><TextField disabled
                                                                         fullWidth
                                                                         value={value.nome}/></Grid>
                <Grid size={12}><TextField disabled fullWidth value={value.email}/></Grid>
            </Grid>
        </Grid>
    </Grid>;
};